import Icon                          from 'components/Icon/Icon.react';
import React                         from 'react';
import Dropzone                      from 'react-dropzone';
import Gravatar                      from 'react-gravatar';
import styles                        from './UploadAvatarOrIcon.scss';
import AccountManager                from 'lib/AccountManager';
import Notification         from 'components/Notification/Notification.react';


export default class UploadAvatarOrIcon extends React.Component {
  constructor(props) {
    super();
    this.state = {
      file: props.image ? props.image : this.defaultImage(props.appIconMode),
      gravatar: props.email && props.use_gravatar ? true : false
    };

    this.onGravatarClick = this.onGravatarClick.bind(this);
    this.onOpenClick = this.onOpenClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let defaultImageURL = this.defaultImage(nextProps.appIconMode);

    if (nextProps.image) {
      if (typeof nextProps.image === 'object') {
        defaultImageURL = nextProps.image.preview
      } else {
        defaultImageURL = nextProps.image
      }
    }

    this.setState({
      file: defaultImageURL,
      gravatar: nextProps.email && this.state.gravatar ? true : false,
    });
  }

  onDrop(files) {
    if(files[0].size > 200000) {
      this.setState({
        note: {
          type: 'error',
          message: "This file is bigger than 200k"
        }
      });
      return null
    }

    this.setState({
      note: {},
      file: files[0].preview,
      gravatar: false
    });

    if(this.props.onChange) {
      this.props.onChange(files[0])
    }
  }

  onGravatarClick() {
    AccountManager.changeAvatar(null, true).then(() =>
    {
      this.setState({
        gravatar: true
      });
    })
  }

  onOpenClick() {
    this.refs.UploadAvatarOrIcon.open();
    this.setState({
      gravatar: false
    });
  }

  defaultImage(img) {
    let defaultImage

    if(img) {
      defaultImage = '/assets/images/default_app_icon.png'
    } else {
      defaultImage = '/assets/images/default-user-avatar.png'
    }

    return defaultImage
  }

  render() {
    let img = (
      this.state.gravatar
        ? <Gravatar email={this.props.email} size={120} default={'mm'} />
        : <img src={this.state.file} />
    );

    let controls = (
      this.props.email
        ?
          <div className={styles.controls}>
            <a className={styles.gravatar} href='javascript:;' onClick={this.onGravatarClick}>Use Gravatar</a>
            <a className={styles.upload} href='javascript:;' onClick={this.onOpenClick}>Upload Your Own</a>
          </div>
        :
          <div className={styles.controls}>
            <a className={styles.gravatar} href='javascript:;' onClick={this.onOpenClick}>Upload</a>
            <a className={styles.upload} href='javascript:;' onClick={this.onOpenClick}>Drop Image</a>
          </div>
    );

    return (
      <Dropzone ref='UploadAvatarOrIcon' onDrop={this.onDrop} accept="image/*" disableClick={true} className={styles.dropzone} activeClassName={styles.dropzoneActive}>
        <div className={[styles.image, !this.state.gravatar ? styles.noGravatar : null].join(' ')}>
          <span className={styles.edit}>
            <Icon width={12} height={12} name={'icon-pencil'} />
          </span>
          <Icon width={140} height={140} name={'icon-dashed-icon'} colored={true} />
          {img}
          {controls}
          <span className={styles.or}>or</span>
          <Notification note={this.state.note} />
        </div>
      </Dropzone>
    );
  }
}
